import type { TAudioSimple, TPagination, TPlaylist } from '@core/models'

type TBuildListPlaylistParams = {
    /** `useCollectionPlayback` matches a collection card against this. */
    id: string
    collectionId?: string
    items: TAudioSimple[]
    pagination: TPagination
    url: string
}

export const buildListPlaylist = ({
    id,
    collectionId,
    items,
    pagination,
    url,
}: TBuildListPlaylistParams): TPlaylist => ({
    id,
    ...(collectionId ? { collectionId } : {}),
    items,
    total: pagination.total,
    pages: pagination.pages,
    page: pagination.page,
    url,
})
